import React, { useMemo, useState, useEffect } from "react";
import { connect } from "react-redux";

import { getTrafficReports, getFailedMDRReports } from "actions/traffic_reports";
import { LS_TRAFFIC_REPORTS_PER_PAGE } from "const/localStorageKeys";
import { renderMoney, isNil, filter, servicePick, resolvePerPage } from "utils";
import { REPORT_DEFAULT_PER_PAGE } from "const";
import { usePrevious } from "hooks";
import TableServer from "components/Table/TableServerSort";
import TableClient from "components/Table/TableClientSort";


const TrafficReportsTable = (props) => {
    const {
        getTrafficReports,
        setSort,
        reportsData = [],
        reportsLoading,
        reportsCount,

        mdrFailedList = [],
        mdrFailedLoading,
        mdrFailedCount,

        getFailedMDRReports,

        isFailedMdr,

        page,
        perPage: _,
        filters,
        service,
        sort
    } = props;


    const dataList = isFailedMdr ? mdrFailedList : reportsData;

    const count = isFailedMdr ? mdrFailedCount : reportsCount;
    const loading = isFailedMdr ? mdrFailedLoading : reportsLoading;

    const prevIsFailedMdr = usePrevious(isFailedMdr);

    const normalizedFilters = filters;

    const isLocalSort = useMemo(() => count < REPORT_DEFAULT_PER_PAGE, [count]);
    const columns = useMemo(() => {
        const trafficReportsColumns = [
            {
                label: "Hour",
                dataKey: "dt_hour",
                value: ({ dt_hour }) => dt_hour ? dt_hour : "",
                width: 120,
                sortable: true
            },
            {
                label: "Day",
                dataKey: "dt_day",
                value: ({ dt_day }) => dt_day ? dt_day : "",
                width: 100,
                sortable: true
            },
            {
                label: "Month",
                dataKey: "dt_month",
                value: ({ dt_month }) => dt_month ? dt_month : "",
                width: 100,
                sortable: true
            },
            {
                label: "Year",
                dataKey: "dt_year",
                value: ({ dt_year }) => dt_year ? dt_year : "",
                width: 100,
                sortable: true
            },
            { label: "Period", dataKey: "group_period", minWidth: 160, sortable: false },
            { label: "Range", dataKey: "range_name", minWidth: 330, title: true, sortable: true },
            { label: "Originator", dataKey: "originator_name", minWidth: 280, sortable: true },
            {
                label: "Originator AM",
                dataKey: "originator_manager_name",
                minWidth: 250,
                sortable: true
            },
            {
                label: "Dialer",
                dataKey: "dialer_name",
                value: ({ dialer_name }) => `${dialer_name}`,
                minWidth: 250,
                sortable: true
            },
            {
                label: "Dialer Nickname",
                dataKey: "dialer_nickname",
                value: ({ dialer_nickname }) => `${dialer_nickname}`,
                minWidth: 160,
                sortable: true
            },
            {
                label: "Dialer AM",
                dataKey: "dialer_manager_name",
                minWidth: 250,
                sortable: true
            },
            { label: "Supplier", dataKey: "supplier_name", minWidth: 200, sortable: true },
            { label: "Zone (origin)", dataKey: "a_wz_name", minWidth: 180, title: true, sortable: true },
            { label: "Zone (dest)", dataKey: "b_wz_name", minWidth: 180, title: true, sortable: true },
            { label: "Dest (origin)", dataKey: "a_de_name", minWidth: 220, title: true, sortable: true },
            { label: "Dest (dest)", dataKey: "b_de_name", minWidth: 220, title: true, sortable: true },
            { label: "Subdest (origin)", dataKey: "a_sde_name", minWidth: 280, title: true, sortable: true },
            { label: "Subdest (dest)", dataKey: "b_sde_name", minWidth: 280, title: true, sortable: true },
            { label: "A-Number", dataKey: "a_number", minWidth: 160, sortable: true },
            {
                label: "Trunk",
                dataKey: "service_plan_name",
                value: ({ service_plan_name }) => `${service_plan_name}`,
                minWidth: 160,
                sortable: true
            },
            { label: "B-Number", dataKey: "b_number", minWidth: 160, sortable: true },
            {
                label: "Margin",
                dataKey: "sum_margin",
                value: ({ sum_margin, sum_cur_name }) => renderMoney(sum_margin, sum_cur_name),
                minWidth: 120,
                // width: 120,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Duration",
                dataKey: "sum_duration",
                value: ({ sum_duration }) => `${sum_duration || "0"}`,
                minWidth: 100,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Cost",
                dataKey: "sum_cost_dialer",
                value: ({ sum_cost_dialer, sum_cur_name }) => renderMoney(sum_cost_dialer, sum_cur_name),
                minWidth: 120,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Originator Rate",
                value: ({ originator_rate }) => renderMoney(originator_rate),
                dataKey: "originator_rate",
                fullLabel: "Originator Rate",
                width: 120,
                sortable: true,
                align: "right"
            },
            {
                label: "Dialer Rate",
                dataKey: "dialer_rate",
                value: ({ dialer_rate }) => renderMoney(dialer_rate),
                fullLabel: "Dialer Rate",
                width: 100,
                sortable: true,
                align: "right"
            },
            {
                label: "Calls",
                dataKey: "count",
                value: ({ count }) => `${count || "0"}`,
                minWidth: 100,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Trusted",
                fullLabel: "Trusted",
                dataKey: "dialer_is_reliable",
                value: ({ dialer_is_reliable }) => {
                    return dialer_is_reliable ? "Yes" : "No";
                },
                defaultValue: ({ dialer_is_reliable }) => {
                    return dialer_is_reliable;
                },
                width: 80,
                sortable: true,
                align: "right"
            }
        ];

        const mdrTrafficReportsColumns = [
            {
                label: "Hour",
                dataKey: "dt_hour",
                value: ({ dt_hour }) => dt_hour ? dt_hour : "",
                width: 120,
                sortable: true
            },
            {
                label: "Day",
                dataKey: "dt_day",
                value: ({ dt_day }) => dt_day ? dt_day : "",
                width: 100,
                sortable: true
            },
            {
                label: "Month",
                dataKey: "dt_month",
                value: ({ dt_month }) => dt_month ? dt_month : "",
                width: 100,
                sortable: true
            },
            {
                label: "Year",
                dataKey: "dt_year",
                value: ({ dt_year }) => dt_year ? dt_year : "",
                width: 100,
                sortable: true
            },
            { label: "Range", dataKey: "range_name", minWidth: 330, title: true, sortable: true },
            {
                label: "Originator",
                dataKey: "originator_name",
                minWidth: 280,
                sortable: true
            },
            {
                label: "Supplier rate",
                dataKey: "supplier_rate",
                value: ({ supplier_rate, supplier_cur_name }) => renderMoney(supplier_rate, supplier_cur_name),
                minWidth: 120,
                sortable: true
            },
            {
                label: "Operator",
                dataKey: "operator",
                minWidth: 200,
                sortable: true
            },
            {
                label: "Country",
                dataKey: "country",
                value: ({ country }) => <span title={country}>{country}</span>,
                minWidth: 185,
                sortable: true
            },
            {
                label: "Supplier",
                dataKey: "supplier_name",
                minWidth: 200,
                sortable: true
            },
            {
                label: "Supplier AM",
                dataKey: "supplier_manager",
                minWidth: 120,
                width: 240,
                sortable: true
            },
            {
                label: "Supplier trunk",
                dataKey: "supplier_trunk",
                minWidth: 160,
                sortable: true
            },
            {
                label: "Dialer rate",
                dataKey: "dialer_rate",
                value: ({ dialer_rate, dialer_cur_name }) => renderMoney(dialer_rate, dialer_cur_name),
                minWidth: 120,
                sortable: true
            },
            {
                label: "Dialer",
                dataKey: "dialer_name",
                value: ({ dialer_name }) => `${dialer_name || "no dialer"}`,
                minWidth: 250,
                sortable: true
            },
            {
                label: "Dialer Nickname",
                dataKey: "dialer_nickname",
                value: ({ dialer_nickname }) => `${dialer_nickname}`,
                minWidth: 160,
                sortable: true
            },
            {
                label: "Trunk",
                dataKey: "service_plan_name",
                value: ({ service_plan_name }) => `${service_plan_name}`,
                minWidth: 160,
                sortable: true
            },
            {
                label: "Dialer AM",
                dataKey: "dialer_manager",
                value: ({ dialer_manager }) => `${dialer_manager || "no manager"}`,
                minWidth: 120,
                width: 240,
                sortable: true
            },
            { label: "B-Number", dataKey: "phone", minWidth: 180, sortable: true },
            { label: "Zone (origin)", dataKey: "sender_wz_name", minWidth: 180, title: true, sortable: true },
            { label: "Zone (dest)", dataKey: "phone_wz_name", minWidth: 180, title: true, sortable: true },
            { label: "Dest (origin)", dataKey: "sender_de_name", minWidth: 220, title: true, sortable: true },
            { label: "Dest (dest)", dataKey: "phone_de_name", minWidth: 220, title: true, sortable: true },
            { label: "Subdest (origin)", dataKey: "sender_sde_name", minWidth: 280, title: true, sortable: true },
            { label: "Subdest (dest)", dataKey: "phone_sde_name", minWidth: 280, title: true, sortable: true },
            { label: "Sender ID", dataKey: "senderid", minWidth: 160, sortable: true },
            {
                label: "Reason",
                dataKey: "reason",
                value: ({ reason }) => {
                    return <a title={reason}>
                        {reason}
                    </a>
                },
                minWidth: 300,
                // width: 700, 
                sortable: true
            },
            { label: "MCC/MNC", dataKey: "mcc_mnc", width: 100, sortable: true },
            { label: "MCC", dataKey: "mcc", width: 100, sortable: true },
            {
                label: "Cost Originator",
                dataKey: "sum_originator_rate",
                value: ({ sum_originator_rate, sum_cur_name }) => renderMoney(sum_originator_rate, sum_cur_name),
                minWidth: 75,
                width: 140,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Cost Dialer",
                dataKey: "sum_dialer_rate",
                value: ({ sum_dialer_rate, sum_cur_name }) => renderMoney(sum_dialer_rate, sum_cur_name),
                minWidth: 75,
                width: 140,
                sortable: true,
                align: "right",
                isDefault: true
            },
            // {
            //     label: "Delivery date",
            //     dataKey: "delivery_datetime",
            //     width: 170,
            //     sortable: false
            // },
            {
                label: "Delivery status",
                dataKey: "delivery_status",
                width: 120,
                sortable: false
            },
            {
                label: "Margin",
                dataKey: "sum_margin",
                value: ({ sum_margin, sum_cur_name }) => renderMoney(sum_margin, sum_cur_name),
                minWidth: 120,
                width: 120,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Messages",
                dataKey: "count",
                value: ({ count }) => count || "0",
                minWidth: 100,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Trusted",
                fullLabel: "Trusted",
                dataKey: "dialer_is_reliable",
                value: ({ dialer_is_reliable }) => {
                    return dialer_is_reliable ? "Yes" : "No";
                },
                defaultValue: ({ dialer_is_reliable }) => {
                    return dialer_is_reliable;
                },
                width: 80,
                sortable: true,
                align: "right"
            }
        ];

        const mdrFailedColumns = [
            {
                label: "Hour",
                dataKey: "dt_hour",
                value: ({ dt_hour }) => dt_hour ? dt_hour : "",
                width: 120,
                sortable: true
            },
            {
                label: "Day",
                dataKey: "dt_day",
                value: ({ dt_day }) => dt_day ? dt_day : "",
                width: 100,
                sortable: true
            },
            {
                label: "Month",
                dataKey: "dt_month",
                value: ({ dt_month }) => dt_month ? dt_month : "",
                width: 100,
                sortable: true
            },
            {
                label: "Year",
                dataKey: "dt_year",
                value: ({ dt_year }) => dt_year ? dt_year : "",
                width: 100,
                sortable: true
            },
            { label: "Range", dataKey: "range_name", minWidth: 330, title: true, sortable: true },
            { label: "Originator", dataKey: "originator_name", minWidth: 280, sortable: true },
            {
                label: "Operator",
                dataKey: "operator",
                minWidth: 200,
                sortable: true
            },
            {
                label: "Country",
                dataKey: "country",
                minWidth: 185,
                sortable: true
            },
            {
                label: "Supplier rate",
                dataKey: "supplier_rate",
                value: ({ supplier_rate, supplier_cur_name }) => renderMoney(supplier_rate, supplier_cur_name),
                minWidth: 120,
                sortable: true
            },
            { label: "Supplier", dataKey: "supplier_name", minWidth: 200, sortable: true },
            {
                label: "Supplier trunk",
                dataKey: "supplier_trunk",
                minWidth: 160,
                sortable: true
            },
            {
                label: "Dialer rate",
                dataKey: "dialer_rate",
                value: ({ dialer_rate, dialer_cur_name }) => renderMoney(dialer_rate, dialer_cur_name),
                minWidth: 120,
                sortable: true
            },
            {
                label: "Dialer",
                dataKey: "dialer_name",
                value: ({ dialer_name, dialer_manager }) => `${dialer_name || "no dialer"} / ${dialer_manager || "no manager"}`,
                minWidth: 400,
                sortable: true
            },
            {
                label: "Dialer Nickname",
                dataKey: "dialer_nickname",
                value: ({ dialer_nickname }) => `${dialer_nickname}`,
                minWidth: 160,
                sortable: true
            },
            { label: "B-Number", dataKey: "phone", minWidth: 180, sortable: true },
            { label: "Zone (origin)", dataKey: "sender_wz_name", minWidth: 180, title: true, sortable: true },
            { label: "Zone (dest)", dataKey: "phone_wz_name", minWidth: 180, title: true, sortable: true },
            { label: "Dest (origin)", dataKey: "sender_de_name", minWidth: 220, title: true, sortable: true },
            { label: "Dest (dest)", dataKey: "phone_de_name", minWidth: 220, title: true, sortable: true },
            { label: "Subdest (origin)", dataKey: "sender_sde_name", minWidth: 280, title: true, sortable: true },
            { label: "Subdest (dest)", dataKey: "phone_sde_name", minWidth: 280, title: true, sortable: true },
            { label: "Sender ID", dataKey: "senderid", minWidth: 160, sortable: true },
            {
                label: "Reason",
                dataKey: "reason",
                value: ({ reason }) => {
                    return <a title={reason}>
                        {reason}
                    </a>;
                },
                minWidth: 300,
                // width: 700, 
                sortable: true
            },
            { label: "MCC/MNC", dataKey: "mcc_mnc", minWidth: 100, sortable: true },
            { label: "MCC", dataKey: "mcc", minWidth: 100, sortable: true },
            {
                label: "Messages",
                dataKey: "count",
                minWidth: 100,
                sortable: true,
                align: "right",
                isDefault: true
            }
        ];

        return isFailedMdr ? mdrFailedColumns : servicePick(service, trafficReportsColumns, mdrTrafficReportsColumns);
    }, [service, isFailedMdr]);

    const [tableColumns, setTableColumns] = useState(columns);

    useEffect(() => {
        if (dataList.length) {
            const serviceColumns = columns;

            const groups = normalizedFilters.group_checkbox;
            //SELECT Columns To SHOW
            const filteredData = filter(serviceColumns, (column) => {
                return !groups.includes(column.dataKey) ? dataList.find(item => !isNil(item[column.dataKey])) || column?.isDefault : true;
            });

            setTableColumns(filteredData);
        }
    }, [service, dataList, normalizedFilters]);

    const getReportsItems = (page = 1, perPage = REPORT_DEFAULT_PER_PAGE, _sort = sort) => {
        if (isFailedMdr) {
            getFailedMDRReports(normalizedFilters, page, perPage, sort);
            return;
        }

        getTrafficReports(service, normalizedFilters, page, perPage, sort);
    };

    useEffect(() => {
        if (isFailedMdr === prevIsFailedMdr) {
            getReportsItems();
        }
    }, [normalizedFilters, isFailedMdr]);

    const tableProps = {
        data: dataList,
        loading: loading,
        columns: tableColumns,
        originalColumns: tableColumns,
        count: count,
        resizable: true,
        perPage: REPORT_DEFAULT_PER_PAGE,
        page: page,
        getItems: getReportsItems,
        showedCount: count,
        onSort: (column, type) => setSort({ column, type }),
        sortType: sort.type,
        sortColumn: sort.column,

        ispagination: true,
        hidePages: isLocalSort,
        hidePerPage: true,
        // perPageLSKey: LS_TRAFFIC_REPORTS_PER_PAGE
    };

    return (<>
        {isLocalSort
            ? <TableClient {...tableProps} />
            : <TableServer {...tableProps} />
        }
    </>);
};

const mapStateToProps = ({ traffic_reports, auth }) => ({
    service: auth.service,

    reportsLoading: traffic_reports.loading,
    reportsData: traffic_reports.list,
    reportsCount: traffic_reports.count,

    mdrFailedLoading: traffic_reports.mdrFailedLoading,
    mdrFailedList: traffic_reports.mdrFailedList,
    mdrFailedCount: traffic_reports.mdrFailedCount,

    page: traffic_reports.page,
    perPage: traffic_reports.per_page,
});

const mapDispatchToProps = {
    getTrafficReports,
    getFailedMDRReports
};

export default connect(mapStateToProps, mapDispatchToProps)(TrafficReportsTable);
